<template>
	<div class="alert" @click.stop="close">
		<div class="alert-box">
			<div class="title">
				
				<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
				&nbsp;&nbsp;{{title}}&nbsp;&nbsp;
				<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
			</div>
			<div class="body">
				<div class="info" v-html="text">

				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Alert",
		data() {
			return {
				text:'',
				title:''
			};
		},
		created() {

		},
		computed: {

		},
		methods: {
			show(title,text) {
				this.title = title
				this.text = text
				document.body.appendChild(this.$el)
			},
			close() {
				document.body.removeChild(this.$el)
			},

		},
	};
</script>
<style scoped>
	.alert {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.2);
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.alert-box {
		border-radius: 6px;
		width: 80%;
		left: 10%;
		margin: 0 auto;
		position: fixed;
		top: 60px;
		overflow: hidden;
	}

	.title {
		background-color: #F6E9B2;
		color: #686e3f;
		padding: 6px;
	}

	.body {
		background-color: #E4C677;
		padding: 10px;

	}

	.info {
		border-radius: 6px;
		background-color: #F6E9B2;
		text-align: left;
		padding: 10px;
		color: #BD8E5B;
		max-height: 400px;
		overflow-y: scroll;
	}
	.decorate{
		width: 20%;
	}
</style>
